<template>
  <div class="w-full md:p-[50px] lg:p-[100px] flex flex-col p-2 gap-[20px]">
    <div
      class="flex flex-col lg:flex-row justify-between py-6 gap-[20px] border-b-1px border-b-tbt-blue"
      v-for="(item, index) in newsData"
      :key="index"
    >
      <!-- Right Section: Image -->
      <div class="w-full">
        <img
          class="w-full h-auto object-cover lg:rounded-[20px] rounded-none"
          :src="item.image_path"
          alt="Events Image"
        />
      </div>
      <!-- Left Section: Title, Date, Description -->
      <div class="flex flex-col px-4 gap-[10px] md:gap-[30px] w-full py-2">
        <h1 class="font-bold text-[20px] md:text-[24px] lg:text-[30px]">
          {{ truncatedDescription(getLocalized(item, "title"), 50) }}
        </h1>

        <h4
          class="px-[10px] py-[6px] rounded-[50px] w-max h-[33px] bg-gray-200 text-sm md:text-base"
        >
          {{ item.create_date }}
        </h4>

        <p class="text-[16px] lg:text-[20px]">
          {{ truncatedDescription(getLocalized(item, "content"), 150) }}
        </p>

        <div>
          <button
            @click="
              $router.push({ name: 'EventsDetail', params: { id: item.id } })
            "
            class="text-tbt-blue font-bold text-base md:text-[20px]"
          >
            Read More
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
export default {
  data() {
    return {
      api: process.env.VUE_APP_API_KEY,
      newsData: [],
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.fetchEvents();
  },
  methods: {
    async fetchEvents() {
      try {
        const response = await axios.get(this.api + "/api/events");
        this.newsData = response.data.items.map((item) => ({
          ...item,
          image_path: `${this.api}${item.image_path}`,
        }));
      } catch (error) {
        console.error(error.messages);
      }
    },
    truncatedDescription(description, length) {
      if (description.length > length) {
        return description.slice(0, length) + "...";
      }
      return description;
    },
  },
};
</script>
